import i18next from 'i18next';

/**
 * Format a money value with grouping separators and the organization's currency symbol.
 * Currency code comes from the org (single currency per org); the locale comes from i18next so
 * grouping and decimal style follow the user's UI language. Returns "—" for null / undefined /
 * NaN so call sites don't need their own guard. Falls back to plain numeric formatting if the
 * currency code is unknown to the runtime.
 *
 * @param {number|string|null|undefined} value
 * @param {string|null|undefined} currency  ISO 4217 code; defaults to USD
 * @param {object} [options]
 * @param {number} [options.minimumFractionDigits=2]
 * @param {number} [options.maximumFractionDigits=2]
 */
export const formatCurrency = (value, currency, options = {}) => {
  if (value === null || value === undefined) return '—';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(num)) return '—';

  const { minimumFractionDigits = 2, maximumFractionDigits = 2 } = options;
  const locale = i18next?.language || undefined;
  const code = currency || 'USD';
  try {
    return num.toLocaleString(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits,
      maximumFractionDigits,
    });
  } catch {
    return num.toLocaleString(locale, {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  }
};

export default formatCurrency;
